// LMT marks the members of these groups wherever it shows a member. Agents
// manage the groups like any other, so membership is a label for agents rather
// than a guarantee: any account can be put in them, and nothing should rely on
// them for access control, service or billing. The groups are created by a
// Firestore migration.

/**
 * Accounts that exist for testing rather than real customers, e.g. the app
 * review members, developer accounts and other testing accounts.
 */
export const TEST_MEMBERS_GROUP_ID = "test-members";

/** VIPs, e.g. high-profile customers, whom agents should treat with extra care. */
export const VIP_MEMBERS_GROUP_ID = "vip-members";

type MemberWithGroups = { groups?: readonly string[] | null };

export function isTestMember(member: MemberWithGroups): boolean {
    return member.groups?.includes(TEST_MEMBERS_GROUP_ID) === true;
}

export function isVipMember(member: MemberWithGroups): boolean {
    return member.groups?.includes(VIP_MEMBERS_GROUP_ID) === true;
}
